define 'controller/CustomDropdownController', ['jquery', 'lib/kryptonite'], ($) ->
  class CustomDropdownController

    constructor: (@$el) ->
      @$dropDownOpener = @$el.find('.js-dropdown-opener')
      @$dropDownOptionsWrap = @$el.find('[data-controller-element=dropdown-options]')

      @_selectCustomDropdown()

    _selectCustomDropdown: ->
      self = @
      @$el.on 'click', '.js-dropdown-opener', (e) ->
        e.preventDefault()
        $opener = self.$el.find('.js-dropdown-opener')
        $this = $(@)
        $this.toggleClass('active')
        self.$el.find("ul").slideToggle()
        if $this.hasClass("active")
          $this.attr("aria-expanded", "true")
        else
          $this.attr("aria-expanded", "false")

      @$el.on 'click', '.custom-dropdown li', (e) ->
        self._selectOption(e)

      $('body').on 'click', (e) ->
        if self.$dropDownOpener.hasClass('active') && !e.target.closest('.custom-dropdown')
          self.$dropDownOpener.click()

    _selectOption: (e) ->
      $el = $(e.currentTarget)
      value = $el.data('value')
      text = $el.data('text')
      color = $el.find('.color-tile img').attr('src')
      $closestCustomDropdown = $el.closest('.custom-dropdown')
      $closestCustomDropdown.removeClass("custom-dropdown--error")
      $closestCustomDropdown.find('li').removeClass('selected')
      $closestCustomDropdown.find('li').attr("aria-selected", "false")
      $closestCustomDropdown.find('input').val(value)
      $closestCustomDropdown.find('.js-dropdown-opener .content').html(text).removeClass("placeholder")
      $closestCustomDropdown.find('.js-dropdown-opener .content-color img').attr('src', color)
      if $el.attr("id")?
        $closestCustomDropdown.find('.js-dropdown-opener').attr("aria-activedescendant", $el.attr("id"))
      $el.addClass('selected')
      $el.attr("aria-selected", "true")
      $closestCustomDropdown.find('.js-dropdown-opener').click()

    destroy: ->
      @$el.off()